// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap__ToDjJ","big_title":"index_big_title__u+bn6","item":"index_item__v4V1Y","title":"index_title__qpKHf","cont":"index_cont__5tMic","time":"index_time__-cuhb"};